import {
    booleanAttribute,
    ChangeDetectionStrategy,
    Component,
    Input,
    ViewEncapsulation
} from '@angular/core';
import { KeyTopicTwoComponent } from '../key-topic-two-block/components/key-topic-two.component';
import { SanitizeUrlPipe } from '../../pipes/sanitize-url.pipe';
import { IconComponent } from '../../../icon/icon.component';
import { NgOptimizedImage } from '@angular/common';

@Component({
    selector: 'nw-press-block',
    imports: [KeyTopicTwoComponent, SanitizeUrlPipe, IconComponent, NgOptimizedImage],
    templateUrl: './press-block.component.html',
    styleUrl: './press-block.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None
})
export class PressBlockComponent {
    @Input() logo?: string;
    @Input() heading!: string;
    @Input() article!: string;
    @Input({ transform: booleanAttribute }) paywall: boolean = false;
    @Input() url!: string;

    public goTo($event: MouseEvent): void {
        if (
            ($event as MouseEvent)?.button !== 0 &&
            ($event as MouseEvent)?.button !== 1
        ) {
            return;
        }

        window.open(this.url, '_blank');
    }
}
